/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
import { UserRating } from "../User/Rating";

export enum Category {
  All = "All",
  Pool = "Pool",
  OutsideView = "OutsideView",
  InsideView = "InsideView",
  Room = "Room",
  FreeTime = "FreeTime",
  Location = "Location",
  Others = "Others",
}

export function categoryFromJSON(object: any): Category {
  switch (object) {
    case 0:
    case "All":
      return Category.All;
    case 1:
    case "Pool":
      return Category.Pool;
    case 2:
    case "OutsideView":
      return Category.OutsideView;
    case 3:
    case "InsideView":
      return Category.InsideView;
    case 4:
    case "Room":
      return Category.Room;
    case 5:
    case "FreeTime":
      return Category.FreeTime;
    case 6:
    case "Location":
      return Category.Location;
    case 7:
    case "Others":
      return Category.Others;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum Category"
      );
  }
}

export function categoryToJSON(object: Category): string {
  switch (object) {
    case Category.All:
      return "All";
    case Category.Pool:
      return "Pool";
    case Category.OutsideView:
      return "OutsideView";
    case Category.InsideView:
      return "InsideView";
    case Category.Room:
      return "Room";
    case Category.FreeTime:
      return "FreeTime";
    case Category.Location:
      return "Location";
    case Category.Others:
      return "Others";
    default:
      return "UNKNOWN";
  }
}

export function categoryToNumber(object: Category): number {
  switch (object) {
    case Category.All:
      return 0;
    case Category.Pool:
      return 1;
    case Category.OutsideView:
      return 2;
    case Category.InsideView:
      return 3;
    case Category.Room:
      return 4;
    case Category.FreeTime:
      return 5;
    case Category.Location:
      return 6;
    case Category.Others:
      return 7;
    default:
      return 0;
  }
}

export enum Orientation {
  OrientationUnknown = "OrientationUnknown",
  Landscape = "Landscape",
  Portrait = "Portrait",
}

export function orientationFromJSON(object: any): Orientation {
  switch (object) {
    case 0:
    case "OrientationUnknown":
      return Orientation.OrientationUnknown;
    case 1:
    case "Landscape":
      return Orientation.Landscape;
    case 2:
    case "Portrait":
      return Orientation.Portrait;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum Orientation"
      );
  }
}

export function orientationToJSON(object: Orientation): string {
  switch (object) {
    case Orientation.OrientationUnknown:
      return "OrientationUnknown";
    case Orientation.Landscape:
      return "Landscape";
    case Orientation.Portrait:
      return "Portrait";
    default:
      return "UNKNOWN";
  }
}

export function orientationToNumber(object: Orientation): number {
  switch (object) {
    case Orientation.OrientationUnknown:
      return 0;
    case Orientation.Landscape:
      return 1;
    case Orientation.Portrait:
      return 2;
    default:
      return 0;
  }
}

export interface Video {
  url: string;
  thumbUrl: string;
  source: string;
  tourOperatorCode: string;
}

export interface Image {
  url: string;
  thumbUrl: string;
  inlineUrl: string;
  source: string;
  tourOperatorCode: string;
  category: Category;
  orientation: Orientation;
}

export interface GuestImage {
  url: string;
  thumbUrl: string;
  originalUrl: string;
  source: string;
  tourOperatorCode: string;
  description: string;
  dateOfTravel: string;
  orientation: Orientation;
  rating?: UserRating;
}

export interface UnitImage {
  unitId: number;
  url: string;
  thumbUrl: string;
  originalUrl: string;
  source: string;
  category: Category;
  orientation: Orientation;
}

export interface HolidayHomeInformation {
  unitNameMap: { [key: number]: string };
}

export interface HolidayHomeInformation_UnitNameMapEntry {
  key: number;
  value: string;
}

export interface HotelMedia {
  imageList: Image[];
  videoList: Video[];
  panoramaList: Image[];
  guestImageList: GuestImage[];
  unitImageList: UnitImage[];
  holidayHomeInformation?: HolidayHomeInformation;
}

function createBaseVideo(): Video {
  return { url: "", thumbUrl: "", source: "", tourOperatorCode: "" };
}

export const Video = {
  encode(message: Video, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    if (message.thumbUrl !== "") {
      writer.uint32(18).string(message.thumbUrl);
    }
    if (message.source !== "") {
      writer.uint32(26).string(message.source);
    }
    if (message.tourOperatorCode !== "") {
      writer.uint32(34).string(message.tourOperatorCode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Video {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVideo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.url = reader.string();
          break;
        case 2:
          message.thumbUrl = reader.string();
          break;
        case 3:
          message.source = reader.string();
          break;
        case 4:
          message.tourOperatorCode = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): Video {
    return {
      url: isSet(object.url) ? String(object.url) : "",
      thumbUrl: isSet(object.thumbUrl) ? String(object.thumbUrl) : "",
      source: isSet(object.source) ? String(object.source) : "",
      tourOperatorCode: isSet(object.tourOperatorCode)
        ? String(object.tourOperatorCode)
        : "",
    };
  },

  toJSON(message: Video): unknown {
    const obj: any = {};
    message.url !== undefined && (obj.url = message.url);
    message.thumbUrl !== undefined && (obj.thumbUrl = message.thumbUrl);
    message.source !== undefined && (obj.source = message.source);
    message.tourOperatorCode !== undefined &&
      (obj.tourOperatorCode = message.tourOperatorCode);
    return obj;
  },

  fromPartial(object: DeepPartial<Video>): Video {
    const message = createBaseVideo();
    message.url = object.url ?? "";
    message.thumbUrl = object.thumbUrl ?? "";
    message.source = object.source ?? "";
    message.tourOperatorCode = object.tourOperatorCode ?? "";
    return message;
  },
};

function createBaseImage(): Image {
  return {
    url: "",
    thumbUrl: "",
    inlineUrl: "",
    source: "",
    tourOperatorCode: "",
    category: Category.All,
    orientation: Orientation.OrientationUnknown,
  };
}

export const Image = {
  encode(message: Image, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    if (message.thumbUrl !== "") {
      writer.uint32(18).string(message.thumbUrl);
    }
    if (message.inlineUrl !== "") {
      writer.uint32(26).string(message.inlineUrl);
    }
    if (message.source !== "") {
      writer.uint32(34).string(message.source);
    }
    if (message.tourOperatorCode !== "") {
      writer.uint32(42).string(message.tourOperatorCode);
    }
    if (message.category !== Category.All) {
      writer.uint32(48).int32(categoryToNumber(message.category));
    }
    if (message.orientation !== Orientation.OrientationUnknown) {
      writer.uint32(56).int32(orientationToNumber(message.orientation));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Image {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.url = reader.string();
          break;
        case 2:
          message.thumbUrl = reader.string();
          break;
        case 3:
          message.inlineUrl = reader.string();
          break;
        case 4:
          message.source = reader.string();
          break;
        case 5:
          message.tourOperatorCode = reader.string();
          break;
        case 6:
          message.category = categoryFromJSON(reader.int32());
          break;
        case 7:
          message.orientation = orientationFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): Image {
    return {
      url: isSet(object.url) ? String(object.url) : "",
      thumbUrl: isSet(object.thumbUrl) ? String(object.thumbUrl) : "",
      inlineUrl: isSet(object.inlineUrl) ? String(object.inlineUrl) : "",
      source: isSet(object.source) ? String(object.source) : "",
      tourOperatorCode: isSet(object.tourOperatorCode)
        ? String(object.tourOperatorCode)
        : "",
      category: isSet(object.category)
        ? categoryFromJSON(object.category)
        : Category.All,
      orientation: isSet(object.orientation)
        ? orientationFromJSON(object.orientation)
        : Orientation.OrientationUnknown,
    };
  },

  toJSON(message: Image): unknown {
    const obj: any = {};
    message.url !== undefined && (obj.url = message.url);
    message.thumbUrl !== undefined && (obj.thumbUrl = message.thumbUrl);
    message.inlineUrl !== undefined && (obj.inlineUrl = message.inlineUrl);
    message.source !== undefined && (obj.source = message.source);
    message.tourOperatorCode !== undefined &&
      (obj.tourOperatorCode = message.tourOperatorCode);
    message.category !== undefined &&
      (obj.category = categoryToJSON(message.category));
    message.orientation !== undefined &&
      (obj.orientation = orientationToJSON(message.orientation));
    return obj;
  },

  fromPartial(object: DeepPartial<Image>): Image {
    const message = createBaseImage();
    message.url = object.url ?? "";
    message.thumbUrl = object.thumbUrl ?? "";
    message.inlineUrl = object.inlineUrl ?? "";
    message.source = object.source ?? "";
    message.tourOperatorCode = object.tourOperatorCode ?? "";
    message.category = object.category ?? Category.All;
    message.orientation = object.orientation ?? Orientation.OrientationUnknown;
    return message;
  },
};

function createBaseGuestImage(): GuestImage {
  return {
    url: "",
    thumbUrl: "",
    originalUrl: "",
    source: "",
    tourOperatorCode: "",
    description: "",
    dateOfTravel: "",
    orientation: Orientation.OrientationUnknown,
    rating: undefined,
  };
}

export const GuestImage = {
  encode(
    message: GuestImage,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    if (message.thumbUrl !== "") {
      writer.uint32(18).string(message.thumbUrl);
    }
    if (message.originalUrl !== "") {
      writer.uint32(26).string(message.originalUrl);
    }
    if (message.source !== "") {
      writer.uint32(34).string(message.source);
    }
    if (message.tourOperatorCode !== "") {
      writer.uint32(42).string(message.tourOperatorCode);
    }
    if (message.description !== "") {
      writer.uint32(50).string(message.description);
    }
    if (message.dateOfTravel !== "") {
      writer.uint32(58).string(message.dateOfTravel);
    }
    if (message.orientation !== Orientation.OrientationUnknown) {
      writer.uint32(64).int32(orientationToNumber(message.orientation));
    }
    if (message.rating !== undefined) {
      UserRating.encode(message.rating, writer.uint32(74).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GuestImage {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGuestImage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.url = reader.string();
          break;
        case 2:
          message.thumbUrl = reader.string();
          break;
        case 3:
          message.originalUrl = reader.string();
          break;
        case 4:
          message.source = reader.string();
          break;
        case 5:
          message.tourOperatorCode = reader.string();
          break;
        case 6:
          message.description = reader.string();
          break;
        case 7:
          message.dateOfTravel = reader.string();
          break;
        case 8:
          message.orientation = orientationFromJSON(reader.int32());
          break;
        case 9:
          message.rating = UserRating.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): GuestImage {
    return {
      url: isSet(object.url) ? String(object.url) : "",
      thumbUrl: isSet(object.thumbUrl) ? String(object.thumbUrl) : "",
      originalUrl: isSet(object.originalUrl) ? String(object.originalUrl) : "",
      source: isSet(object.source) ? String(object.source) : "",
      tourOperatorCode: isSet(object.tourOperatorCode)
        ? String(object.tourOperatorCode)
        : "",
      description: isSet(object.description) ? String(object.description) : "",
      dateOfTravel: isSet(object.dateOfTravel)
        ? String(object.dateOfTravel)
        : "",
      orientation: isSet(object.orientation)
        ? orientationFromJSON(object.orientation)
        : Orientation.OrientationUnknown,
      rating: isSet(object.rating)
        ? UserRating.fromJSON(object.rating)
        : undefined,
    };
  },

  toJSON(message: GuestImage): unknown {
    const obj: any = {};
    message.url !== undefined && (obj.url = message.url);
    message.thumbUrl !== undefined && (obj.thumbUrl = message.thumbUrl);
    message.originalUrl !== undefined &&
      (obj.originalUrl = message.originalUrl);
    message.source !== undefined && (obj.source = message.source);
    message.tourOperatorCode !== undefined &&
      (obj.tourOperatorCode = message.tourOperatorCode);
    message.description !== undefined &&
      (obj.description = message.description);
    message.dateOfTravel !== undefined &&
      (obj.dateOfTravel = message.dateOfTravel);
    message.orientation !== undefined &&
      (obj.orientation = orientationToJSON(message.orientation));
    message.rating !== undefined &&
      (obj.rating = message.rating
        ? UserRating.toJSON(message.rating)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<GuestImage>): GuestImage {
    const message = createBaseGuestImage();
    message.url = object.url ?? "";
    message.thumbUrl = object.thumbUrl ?? "";
    message.originalUrl = object.originalUrl ?? "";
    message.source = object.source ?? "";
    message.tourOperatorCode = object.tourOperatorCode ?? "";
    message.description = object.description ?? "";
    message.dateOfTravel = object.dateOfTravel ?? "";
    message.orientation = object.orientation ?? Orientation.OrientationUnknown;
    message.rating =
      object.rating !== undefined && object.rating !== null
        ? UserRating.fromPartial(object.rating)
        : undefined;
    return message;
  },
};

function createBaseUnitImage(): UnitImage {
  return {
    unitId: 0,
    url: "",
    thumbUrl: "",
    originalUrl: "",
    source: "",
    category: Category.All,
    orientation: Orientation.OrientationUnknown,
  };
}

export const UnitImage = {
  encode(
    message: UnitImage,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.unitId !== 0) {
      writer.uint32(16).uint32(message.unitId);
    }
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    if (message.thumbUrl !== "") {
      writer.uint32(26).string(message.thumbUrl);
    }
    if (message.originalUrl !== "") {
      writer.uint32(34).string(message.originalUrl);
    }
    if (message.source !== "") {
      writer.uint32(42).string(message.source);
    }
    if (message.category !== Category.All) {
      writer.uint32(48).int32(categoryToNumber(message.category));
    }
    if (message.orientation !== Orientation.OrientationUnknown) {
      writer.uint32(56).int32(orientationToNumber(message.orientation));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UnitImage {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnitImage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          message.unitId = reader.uint32();
          break;
        case 1:
          message.url = reader.string();
          break;
        case 3:
          message.thumbUrl = reader.string();
          break;
        case 4:
          message.originalUrl = reader.string();
          break;
        case 5:
          message.source = reader.string();
          break;
        case 6:
          message.category = categoryFromJSON(reader.int32());
          break;
        case 7:
          message.orientation = orientationFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): UnitImage {
    return {
      unitId: isSet(object.unitId) ? Number(object.unitId) : 0,
      url: isSet(object.url) ? String(object.url) : "",
      thumbUrl: isSet(object.thumbUrl) ? String(object.thumbUrl) : "",
      originalUrl: isSet(object.originalUrl) ? String(object.originalUrl) : "",
      source: isSet(object.source) ? String(object.source) : "",
      category: isSet(object.category)
        ? categoryFromJSON(object.category)
        : Category.All,
      orientation: isSet(object.orientation)
        ? orientationFromJSON(object.orientation)
        : Orientation.OrientationUnknown,
    };
  },

  toJSON(message: UnitImage): unknown {
    const obj: any = {};
    message.unitId !== undefined && (obj.unitId = Math.round(message.unitId));
    message.url !== undefined && (obj.url = message.url);
    message.thumbUrl !== undefined && (obj.thumbUrl = message.thumbUrl);
    message.originalUrl !== undefined &&
      (obj.originalUrl = message.originalUrl);
    message.source !== undefined && (obj.source = message.source);
    message.category !== undefined &&
      (obj.category = categoryToJSON(message.category));
    message.orientation !== undefined &&
      (obj.orientation = orientationToJSON(message.orientation));
    return obj;
  },

  fromPartial(object: DeepPartial<UnitImage>): UnitImage {
    const message = createBaseUnitImage();
    message.unitId = object.unitId ?? 0;
    message.url = object.url ?? "";
    message.thumbUrl = object.thumbUrl ?? "";
    message.originalUrl = object.originalUrl ?? "";
    message.source = object.source ?? "";
    message.category = object.category ?? Category.All;
    message.orientation = object.orientation ?? Orientation.OrientationUnknown;
    return message;
  },
};

function createBaseHolidayHomeInformation(): HolidayHomeInformation {
  return { unitNameMap: {} };
}

export const HolidayHomeInformation = {
  encode(
    message: HolidayHomeInformation,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    Object.entries(message.unitNameMap).forEach(([key, value]) => {
      HolidayHomeInformation_UnitNameMapEntry.encode(
        { key: key as any, value },
        writer.uint32(10).fork()
      ).ldelim();
    });
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): HolidayHomeInformation {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHolidayHomeInformation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          const entry1 = HolidayHomeInformation_UnitNameMapEntry.decode(
            reader,
            reader.uint32()
          );
          if (entry1.value !== undefined) {
            message.unitNameMap[entry1.key] = entry1.value;
          }
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): HolidayHomeInformation {
    return {
      unitNameMap: isObject(object.unitNameMap)
        ? Object.entries(object.unitNameMap).reduce<{ [key: number]: string }>(
            (acc, [key, value]) => {
              acc[Number(key)] = String(value);
              return acc;
            },
            {}
          )
        : {},
    };
  },

  toJSON(message: HolidayHomeInformation): unknown {
    const obj: any = {};
    obj.unitNameMap = {};
    if (message.unitNameMap) {
      Object.entries(message.unitNameMap).forEach(([k, v]) => {
        obj.unitNameMap[k] = v;
      });
    }
    return obj;
  },

  fromPartial(
    object: DeepPartial<HolidayHomeInformation>
  ): HolidayHomeInformation {
    const message = createBaseHolidayHomeInformation();
    message.unitNameMap = Object.entries(object.unitNameMap ?? {}).reduce<{
      [key: number]: string;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[Number(key)] = String(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseHolidayHomeInformation_UnitNameMapEntry(): HolidayHomeInformation_UnitNameMapEntry {
  return { key: 0, value: "" };
}

export const HolidayHomeInformation_UnitNameMapEntry = {
  encode(
    message: HolidayHomeInformation_UnitNameMapEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== 0) {
      writer.uint32(8).uint32(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): HolidayHomeInformation_UnitNameMapEntry {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHolidayHomeInformation_UnitNameMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.uint32();
          break;
        case 2:
          message.value = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): HolidayHomeInformation_UnitNameMapEntry {
    return {
      key: isSet(object.key) ? Number(object.key) : 0,
      value: isSet(object.value) ? String(object.value) : "",
    };
  },

  toJSON(message: HolidayHomeInformation_UnitNameMapEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = Math.round(message.key));
    message.value !== undefined && (obj.value = message.value);
    return obj;
  },

  fromPartial(
    object: DeepPartial<HolidayHomeInformation_UnitNameMapEntry>
  ): HolidayHomeInformation_UnitNameMapEntry {
    const message = createBaseHolidayHomeInformation_UnitNameMapEntry();
    message.key = object.key ?? 0;
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseHotelMedia(): HotelMedia {
  return {
    imageList: [],
    videoList: [],
    panoramaList: [],
    guestImageList: [],
    unitImageList: [],
    holidayHomeInformation: undefined,
  };
}

export const HotelMedia = {
  encode(
    message: HotelMedia,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    for (const v of message.imageList) {
      Image.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.videoList) {
      Video.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.panoramaList) {
      Image.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    for (const v of message.guestImageList) {
      GuestImage.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    for (const v of message.unitImageList) {
      UnitImage.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    if (message.holidayHomeInformation !== undefined) {
      HolidayHomeInformation.encode(
        message.holidayHomeInformation,
        writer.uint32(50).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HotelMedia {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHotelMedia();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.imageList.push(Image.decode(reader, reader.uint32()));
          break;
        case 2:
          message.videoList.push(Video.decode(reader, reader.uint32()));
          break;
        case 3:
          message.panoramaList.push(Image.decode(reader, reader.uint32()));
          break;
        case 4:
          message.guestImageList.push(
            GuestImage.decode(reader, reader.uint32())
          );
          break;
        case 5:
          message.unitImageList.push(UnitImage.decode(reader, reader.uint32()));
          break;
        case 6:
          message.holidayHomeInformation = HolidayHomeInformation.decode(
            reader,
            reader.uint32()
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): HotelMedia {
    return {
      imageList: Array.isArray(object?.imageList)
        ? object.imageList.map((e: any) => Image.fromJSON(e))
        : [],
      videoList: Array.isArray(object?.videoList)
        ? object.videoList.map((e: any) => Video.fromJSON(e))
        : [],
      panoramaList: Array.isArray(object?.panoramaList)
        ? object.panoramaList.map((e: any) => Image.fromJSON(e))
        : [],
      guestImageList: Array.isArray(object?.guestImageList)
        ? object.guestImageList.map((e: any) => GuestImage.fromJSON(e))
        : [],
      unitImageList: Array.isArray(object?.unitImageList)
        ? object.unitImageList.map((e: any) => UnitImage.fromJSON(e))
        : [],
      holidayHomeInformation: isSet(object.holidayHomeInformation)
        ? HolidayHomeInformation.fromJSON(object.holidayHomeInformation)
        : undefined,
    };
  },

  toJSON(message: HotelMedia): unknown {
    const obj: any = {};
    if (message.imageList) {
      obj.imageList = message.imageList.map((e) =>
        e ? Image.toJSON(e) : undefined
      );
    } else {
      obj.imageList = [];
    }
    if (message.videoList) {
      obj.videoList = message.videoList.map((e) =>
        e ? Video.toJSON(e) : undefined
      );
    } else {
      obj.videoList = [];
    }
    if (message.panoramaList) {
      obj.panoramaList = message.panoramaList.map((e) =>
        e ? Image.toJSON(e) : undefined
      );
    } else {
      obj.panoramaList = [];
    }
    if (message.guestImageList) {
      obj.guestImageList = message.guestImageList.map((e) =>
        e ? GuestImage.toJSON(e) : undefined
      );
    } else {
      obj.guestImageList = [];
    }
    if (message.unitImageList) {
      obj.unitImageList = message.unitImageList.map((e) =>
        e ? UnitImage.toJSON(e) : undefined
      );
    } else {
      obj.unitImageList = [];
    }
    message.holidayHomeInformation !== undefined &&
      (obj.holidayHomeInformation = message.holidayHomeInformation
        ? HolidayHomeInformation.toJSON(message.holidayHomeInformation)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<HotelMedia>): HotelMedia {
    const message = createBaseHotelMedia();
    message.imageList =
      object.imageList?.map((e) => Image.fromPartial(e)) || [];
    message.videoList =
      object.videoList?.map((e) => Video.fromPartial(e)) || [];
    message.panoramaList =
      object.panoramaList?.map((e) => Image.fromPartial(e)) || [];
    message.guestImageList =
      object.guestImageList?.map((e) => GuestImage.fromPartial(e)) || [];
    message.unitImageList =
      object.unitImageList?.map((e) => UnitImage.fromPartial(e)) || [];
    message.holidayHomeInformation =
      object.holidayHomeInformation !== undefined &&
      object.holidayHomeInformation !== null
        ? HolidayHomeInformation.fromPartial(object.holidayHomeInformation)
        : undefined;
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
